import React from "react";
import "./footer.css";

const BLOG_URL = "https://blog.spinosoftbits.com";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__decoration"></div>
      <div className="footer__decoration"></div>

      <div className="footer__container container">
        <div className="footer__content">
          {/* Brand */}
          <div className="footer__brand">
            <span className="footer__eyebrow">Brooklyn-based software studio</span>
            <h2 className="footer__title">SpinoSoftBits</h2>
            <p className="footer__tagline">Production software for real businesses.</p>
            <p className="footer__description">
              I'm Spinoza Delva, a full-stack developer building fast, reliable
              web apps for restaurants, shops, and small businesses: online
              ordering, storefronts, payments, and custom platforms.
            </p>

            <div className="footer__social">
              <a
                href="https://www.linkedin.com/in/spinozadelva/"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <i className="bx bxl-linkedin"></i>
              </a>
              <a
                href="https://github.com/SpinozaDelva"
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <i className="bx bxl-github"></i>
              </a>
              <a
                href={BLOG_URL}
                className="footer__social-link"
                target="_blank"
                rel="noreferrer"
                aria-label="Blog"
              >
                <i className="bx bx-news"></i>
              </a>
              <a
                href="mailto:spinozadelva@gmail.com"
                className="footer__social-link"
                aria-label="Email"
              >
                <i className="bx bx-envelope"></i>
              </a>
            </div>
          </div>

          {/* Explore */}
          <div className="footer__column">
            <h3>Explore</h3>
            <ul className="footer__list">
              <li><a href="#home" className="footer__link">Home</a></li>
              <li><a href="#about" className="footer__link">About</a></li>
              <li><a href="#portfolio" className="footer__link">Portfolio</a></li>
              <li><a href="#contact" className="footer__link">Contact</a></li>
              <li>
                <a
                  href={BLOG_URL}
                  className="footer__link"
                  target="_blank"
                  rel="noreferrer"
                >
                  Blog &#8599;
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer__column">
            <h3>Services</h3>
            <ul className="footer__list">
              <li><a href="#services" className="footer__link">Digital services</a></li>
              <li><a href="#services" className="footer__link">Small Business WebApp</a></li>
              <li><a href="#services" className="footer__link">E-Commerce</a></li>
              <li><a href="#services" className="footer__link">Custom Web Apps</a></li>
              <li><a href="#services" className="footer__link">Maintenance &amp; SEO</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__column">
            <h3>Get in Touch</h3>
            <div className="footer__contact">
              <a href="mailto:spinozadelva@gmail.com" className="footer__contact-item">
                <i className="bx bx-mail-send"></i>
                <span>spinozadelva@gmail.com</span>
              </a>
              <a href="tel:+19178087320" className="footer__contact-item">
                <i className="bx bx-phone"></i>
                <span>(917) 808-7320</span>
              </a>
              <div className="footer__contact-item">
                <i className="bx bx-map"></i>
                <span>Brooklyn, NY</span>
              </div>
            </div>

            <a
              href={BLOG_URL}
              className="footer__blog-cta"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bx bx-book-open"></i>
              <span>Read the blog</span>
              <i className="bx bx-right-arrow-alt footer__blog-arrow"></i>
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <span className="footer__copy">
            &#169; {year} Spinoza Delva &middot; SpinoSoftBits. All rights reserved.
          </span>

          <div className="footer__credits">
            <a href="/privacy" className="footer__credit-link">Privacy</a>
            <a href="/terms" className="footer__credit-link">Terms</a>
            <a href="#contact" className="footer__credit-link">Get a Quote</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;